import {FormElementType} from "~/enums/formElementType"

export default class FormElementControlGroups {
  static readonly ALL_CONTROLS = [
    FormElementType.textField,
    FormElementType.dateTimePicker,
    FormElementType.textArea,
    FormElementType.uploadFiles,
    FormElementType.imageUpload,
    FormElementType.signature,
    FormElementType.dropdown,
    FormElementType.checkboxGroup,
    FormElementType.radioButtonGroup,
    FormElementType.checkbox,
    FormElementType.radioButton,
    FormElementType.dropdownItem,
    FormElementType.heading,
    FormElementType.subheading,
    FormElementType.paragraph,
    FormElementType.stack,
    FormElementType.grid,
    FormElementType.pageBreak,
    FormElementType.divider,
    FormElementType.validator,
    FormElementType.thirdParty,
    FormElementType.lookupField,
    FormElementType.USPSAddress,
    FormElementType.panValidation,
    FormElementType.MMCCProviderValidation,
  ];

  static readonly SELECTABLE_CONTROLS = [
    FormElementType.textField,
    FormElementType.dateTimePicker,
    FormElementType.textArea,
    FormElementType.uploadFiles,
    FormElementType.imageUpload,
    FormElementType.signature,
    FormElementType.dropdown,
    FormElementType.checkboxGroup,
    FormElementType.radioButtonGroup,
    FormElementType.heading,
    FormElementType.subheading,
    FormElementType.paragraph,
    FormElementType.stack,
    FormElementType.grid,
    FormElementType.pageBreak,
    FormElementType.divider,
    FormElementType.validator,
    FormElementType.thirdParty,
    FormElementType.lookupField,
    FormElementType.USPSAddress,
    FormElementType.panValidation,
    FormElementType.MMCCProviderValidation,
    FormElementType.checkbox,
  ];

  static readonly SHOW_HIDDEABLE_CONTROLS = [
    FormElementType.textField,
    FormElementType.dateTimePicker,
    FormElementType.textArea,
    FormElementType.uploadFiles,
    FormElementType.imageUpload,
    FormElementType.signature,
    FormElementType.dropdown,
    FormElementType.checkboxGroup,
    FormElementType.radioButtonGroup,
    FormElementType.radioButton,
    FormElementType.dropdownItem,
    FormElementType.heading,
    FormElementType.subheading,
    FormElementType.paragraph,
    FormElementType.stack,
    FormElementType.grid,
    FormElementType.divider,
    FormElementType.thirdParty,
    FormElementType.lookupField,
    FormElementType.USPSAddress,
    FormElementType.panValidation,
    FormElementType.MMCCProviderValidation,
  ]

  static readonly LABELABLE_CONTROLS = [
    FormElementType.textField,
    FormElementType.dateTimePicker,
    FormElementType.textArea,
    FormElementType.uploadFiles,
    FormElementType.imageUpload,
    FormElementType.signature,
    FormElementType.dropdown,
    FormElementType.checkboxGroup,
    FormElementType.radioButtonGroup,
    FormElementType.checkbox,
    FormElementType.radioButton,
    FormElementType.dropdownItem,
    FormElementType.heading,
    FormElementType.subheading,
    FormElementType.thirdParty,
    FormElementType.lookupField,
    FormElementType.panValidation,
    FormElementType.USPSAddress,
    FormElementType.MMCCProviderValidation,
  ];

  static readonly WYSIWYG_LABELABLE_CONTROLS = [
    FormElementType.paragraph,
    FormElementType.validator,
  ];

  static readonly PLACEHOLDERABLE_CONTROLS = [
    FormElementType.textField,
    FormElementType.dateTimePicker,
    FormElementType.textArea,
    FormElementType.signature,
    FormElementType.lookupField
  ];

  static readonly REQUIREABLE_CONTROLS = [
    FormElementType.textField,
    FormElementType.dateTimePicker,
    FormElementType.textArea,
    FormElementType.uploadFiles,
    FormElementType.imageUpload,
    FormElementType.signature,
    FormElementType.dropdown,
    FormElementType.checkboxGroup,
    FormElementType.radioButtonGroup,
    FormElementType.lookupField
  ];

  static readonly FORMATABLE_CONTROLS = [
    FormElementType.textField,
  ];

  static readonly LENGTHABLE_CONTROLS = [
    FormElementType.textField,
    FormElementType.textArea,
  ];

  static readonly REFERENCEABLE_CONTROLS = [
    FormElementType.textField,
    FormElementType.dateTimePicker,
    FormElementType.textArea,
    FormElementType.dropdown,
    FormElementType.checkboxGroup,
    FormElementType.radioButtonGroup,
    FormElementType.stack,
    FormElementType.grid,
    FormElementType.thirdParty,
    FormElementType.uploadFiles,
    FormElementType.imageUpload,
    FormElementType.lookupField,
    FormElementType.USPSAddress,
    FormElementType.panValidation,
    FormElementType.MMCCProviderValidation,
  ];

  /**
   * The elements that are stored in a form submission step using the client id of the parent
   * as the key and the client id of this element as the value (or array of values)
   */
  static readonly SUBREFERENCEABLE_CONTROLS = [
    FormElementType.dropdownItem,
    FormElementType.checkbox,
    FormElementType.radioButton,
  ];

  static readonly HELP_TEXTABLE_CONTROLS = [
    FormElementType.textField,
    FormElementType.dateTimePicker,
    FormElementType.textArea,
    FormElementType.uploadFiles,
    FormElementType.imageUpload,
    FormElementType.signature,
    FormElementType.dropdown,
    FormElementType.checkboxGroup,
    FormElementType.radioButtonGroup,
    FormElementType.heading,
    FormElementType.subheading,
    FormElementType.paragraph,
    FormElementType.stack,
    FormElementType.grid,
    FormElementType.thirdParty,
    FormElementType.lookupField,
    FormElementType.USPSAddress,
    FormElementType.panValidation,
    FormElementType.MMCCProviderValidation,
  ];

  static readonly REPEATABLE_CONTROLS = [
    FormElementType.textField,
    FormElementType.dateTimePicker,
    FormElementType.textArea,
    FormElementType.dropdown,
    FormElementType.checkboxGroup,
    FormElementType.radioButtonGroup,
    FormElementType.stack,
    FormElementType.grid,
    FormElementType.thirdParty
  ];

  static readonly DEFAULTABLE_CONTROLS = [
    FormElementType.textField,
    FormElementType.textArea,

  ];

  static readonly MASKABLE_CONTROLS = [
    FormElementType.textField
  ];

  static readonly LAYOUTABLE_CONTROLS = [
    FormElementType.grid
  ];

  static readonly LAYOUT_CONTAINER_CONTROLS = [
    FormElementType.grid,
    FormElementType.stack
  ];

  static readonly NUMERIC_MIN_MAXABLE_CONTROLS = [
    FormElementType.textField,
  ];

  static readonly DATE_MIN_MAXABLE_CONTROLS = [
    FormElementType.dateTimePicker,
  ];

  static readonly COLUMNABLE_CONTROLS = [
    FormElementType.checkboxGroup,
    FormElementType.radioButtonGroup
  ];

  static readonly SIZEABLE_FONT_CONTROLS = [
    FormElementType.heading,
    FormElementType.subheading
  ];

  static readonly OPTION_COLLECTION_CONTROLS = [
    FormElementType.checkboxGroup,
    FormElementType.radioButtonGroup,
    FormElementType.dropdown,
  ];

  static readonly OPTION_CONTROLS = [
    FormElementType.checkbox,
    FormElementType.radioButton,
    FormElementType.dropdownItem,
  ];

  static readonly DEFAULT_OPTION_CONTROLS = [
    FormElementType.dropdown
  ];

  static readonly DEFAULT_CLICK_CONTROLS = [
    FormElementType.checkbox,
    FormElementType.radioButton,
  ];

  static readonly OPTION_RANGE_REQUIRABLE_CONTROLS = [
    FormElementType.checkboxGroup
  ];

  static readonly READONLYABLE_CONTROLS = [
    FormElementType.textField,
    FormElementType.dateTimePicker,
    FormElementType.textArea,
    FormElementType.dropdown,
    FormElementType.checkboxGroup,
    FormElementType.radioButtonGroup,
    FormElementType.radioButton,
    FormElementType.dropdownItem,
  ];

  static readonly INDEXABLE_CONTROLS: FormElementType[] = [
    FormElementType.textField,
    FormElementType.dateTimePicker,
    FormElementType.checkboxGroup,
    FormElementType.radioButtonGroup,
    FormElementType.dropdown,
    FormElementType.lookupField
  ];

  static readonly VERTICAL_ALIGN = [
    FormElementType.grid,
    FormElementType.template
  ];

  static readonly RESIZABLE_CONTROLS = [
    FormElementType.imageUpload,
  ];

  static readonly DATA_REFERENCABLE_CONTROLS: FormElementType[] = [
    FormElementType.lookupField
  ];

  static readonly PROFILE_CONFIG_CONTROLS: FormElementType[] = [
    FormElementType.textArea,
    FormElementType.textField
  ]

  static readonly VALIDATION_RULE_CONTROLS: FormElementType[] = [
    FormElementType.validator
  ]

  static readonly DISPLAY_LABLEABLE_CONTROLS: FormElementType[]=[
    FormElementType.checkbox,
  ]

  static readonly VISUAL_CONTROLS: FormElementType[] = [
    FormElementType.subheading,
    FormElementType.heading,
    FormElementType.pageBreak,
    FormElementType.validator,
    FormElementType.paragraph,
    FormElementType.divider,
  ]

  static readonly TEMPLATE_CONTROLS: FormElementType[] = [
    FormElementType.template,
    FormElementType.panValidation,
    FormElementType.thirdParty,
    FormElementType.USPSAddress,
    FormElementType.MMCCProviderValidation,
  ]

  static readonly UPLOAD_CONTROLS: FormElementType[] = [
    FormElementType.uploadFiles,
    FormElementType.imageUpload,
  ]

  static readonly SIGNATURE_CONTROLS: FormElementType[] = [
    FormElementType.signature,
  ]

  static readonly LOOKUP_CONTROLS: FormElementType[] = [
    FormElementType.lookupField,
  ]

  static readonly WYSIWYG_FORMATTABLE_CONTROLS: FormElementType[] = [
    FormElementType.textArea
  ]

  /**
   * Any element that may contain other elements
   */
  static readonly CONTAINER_CONTROLS: FormElementType[] = [
    ...FormElementControlGroups.TEMPLATE_CONTROLS,
    ...FormElementControlGroups.LAYOUT_CONTAINER_CONTROLS,
  ]

  static readonly SUBMISSION_COMMENTABLE_CONTROLS: FormElementType[] = [
    FormElementType.textField,
    FormElementType.textArea,
    FormElementType.dropdown,
    FormElementType.checkboxGroup,
    FormElementType.radioButtonGroup,
    FormElementType.dateTimePicker,
    FormElementType.uploadFiles,
    FormElementType.imageUpload,
    FormElementType.signature,
    FormElementType.lookupField,
    FormElementType.grid,
    FormElementType.stack,
  ]

  static readonly VALIDATION_MODE_CONTROLS: FormElementType[] = [
    FormElementType.pageBreak,
  ]
}